import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Toolbar, Button } from '@mui/material';
import { useAuth } from "../../AuthContext";

function AskNavBar() {
  const { role, roles, loggedIn } = useAuth();
  const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];
  const allowedRoles = ['anthra-sales-executive', 'admin', 'expert'];

  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div>
      {loggedIn && (
        <Box position="static" color="primary" sx={{ mt: 7, backgroundColor: '#000000' }}>
          <Toolbar>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>
              
              {/* Ask Button */}
              <Button
                variant={isActive('/ask-expert') ? 'contained' : 'outlined'}
                color={isActive('/ask-expert') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/ask-expert')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/ask-expert') ? 'secondary.main' : 'transparent',
                  color: isActive('/ask-expert') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/ask-expert') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/ask-expert') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Ask
              </Button>

              {/* Manage Button */}
              <Button
                variant={isActive('/my-requests-list') ? 'contained' : 'outlined'}
                color={isActive('/my-requests-list') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/my-requests-list')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/my-requests-list') ? 'secondary.main' : 'transparent',
                  color: isActive('/my-requests-list') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/my-requests-list') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/my-requests-list') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Manage
              </Button>

              {/* Expert Mode Button - Only for allowed roles */}
              {allowedRoles.some(r => userRoles.includes(r)) && (
                <Button
                  variant={isActive('/my-requests-list-expert') ? 'contained' : 'outlined'}
                  color={isActive('/my-requests-list-expert') ? 'secondary' : 'inherit'}
                  onClick={() => navigate('/my-requests-list-expert')}
                  sx={{
                    borderRadius: '20px',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    px: 3,
                    py: 1,
                    bgcolor: isActive('/my-requests-list-expert') ? 'secondary.main' : 'transparent',
                    color: isActive('/my-requests-list-expert') ? 'white' : 'inherit',
                    border: '2px solid',
                    borderColor: isActive('/my-requests-list-expert') ? 'primary.main' : 'inherit',
                    '&:hover': {
                      bgcolor: isActive('/my-requests-list-expert') ? 'secondary.dark' : 'action.hover',
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  Expert Mode
                </Button>
              )}

            </Box>
          </Toolbar>
        </Box>
      )}
    </div>
  );
}

export default AskNavBar;
